import { transparentize } from 'polished'
import { StyleFn } from '..'

export const Divider: StyleFn = ({ color, size }) => {
  const borderColor = color.type === 'light' ? color.palette.coolgrey['30'] : transparentize(0.5, color.palette.white)

  return {
    root: {
      width: 'auto',
      height: 'auto',
      display: 'block',
      border: 0,
      borderBottom: `1px solid ${borderColor}`,
      margin: `${size.spacing[8]} 0`,
    },
    _vertical: {
      borderBottom: 0,
      borderLeft: `1px solid ${borderColor}`,
      margin: `0 ${size.spacing[8]}`,
      boxSizing: 'content-box',
      alignSelf: 'stretch',
    },
    _inset: {
      marginLeft: `${size.spacing[16]}`,
      marginRight: `${size.spacing[16]}`,
    },
    _dense: {
      margin: 0,
    },
  }
}
